import { ChildServiceId } from '../types/IChildService';

export default (ids: number[]): ChildServiceId[] => {
    const attributeIds = new Set(ids);
    const result: ChildServiceId[] = [];

    if (attributeIds.has(229)) result.push(ChildServiceId.Animators);
    if (attributeIds.has(111)) result.push(ChildServiceId.Pool);
    if (attributeIds.has(163)) result.push(ChildServiceId.Menu);
    if (attributeIds.has(109)) result.push(ChildServiceId.Playroom);
    if (attributeIds.has(112)) result.push(ChildServiceId.Clubs);
    if (attributeIds.has(114) || attributeIds.has(246) || attributeIds.has(247)) result.push(ChildServiceId.Bed);
    if (attributeIds.has(113) || attributeIds.has(110)) result.push(ChildServiceId.Nanny);
    return result;
};
